import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../Layout";
import List from "../Components/Counter/List";
import View from "../Components/Counter/CounterWiseGraphView";
import { useSelector } from "react-redux";
import * as utils from "../Utils/comman";
import Add from "../Components/Counter/Add";
import AssetsHistory from "../Components/Assets/AssetsHistory";

function MainCounter() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();
  const [currentOrder, setCurrentorder] = useState({});
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const [invertId, setInvertId] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  function renderComponent() {
    switch (comp) {
      case "list":
        return (
          <List
            comp={comp}
            onChange={handleChange}
            rowData={rowData}
            setIsEdit={setIsEdit}
          />
        );
      case "view": 
        return <View comp={comp} rowData={rowData} onChange={handleChange} />;

      // default:
      //   return (
      //     <Add
      //       comp={comp}
      //       rowData={rowData}
      //       onChange={handleChange}
      //       isEdit={isEdit}
      //     />
      //   );
    }
  }

  return <>{renderComponent()}</>;
}

export default MainCounter;
